import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import LayoutV1 from "markup/Layout/LayoutV1";
import * as advertEndpoint from "modules/Advert/_redux/advertEndpoint";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import AdvertCard from "../Main/parts/AdvertCard";
import AdvertCardListView from "../Main/parts/AdvertCardListView";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";
import "../Category/parts/filters/sahibindenFilters.css";
import "./SearchResults.css";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  // Kategori sayfasındaki "Görüntüle" etiketiyle aynı stil.
  contentStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    padding: "6px 16px",
    minWidth: "64px",
    boxSizing: "border-box",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    lineHeight: 1.75,
    borderRadius: "4px",
    letterSpacing: "0.02857em",
    textTransform: "uppercase",
    fontSize: "10px",
    margin: 0,
  },
}));

// Kategori sayfasıyla birebir aynı sıralama seçenekleri/etiketleri.
const SORT_OPTIONS = [
  { id: "newest", label: "En yeni" },
  { id: "oldest", label: "En eski" },
  { id: "priceAsc", label: "Fiyat: artan" },
  { id: "priceDesc", label: "Fiyat: azalan" },
];

// Alıcı ilanında priceMin, satıcı ilanında price sıralama referansı olur.
function advertSortPrice(a) {
  if (a.kind === "seller") return Number(a.price) || 0;
  return Number(a.priceMin) || Number(a.priceMax) || 0;
}

function sortAdverts(items, sortBy) {
  const arr = [...items];
  switch (sortBy) {
    case "oldest":
      return arr.sort(
        (x, y) => new Date(x.createdAt) - new Date(y.createdAt)
      );
    case "priceAsc":
      return arr.sort((x, y) => advertSortPrice(x) - advertSortPrice(y));
    case "priceDesc":
      return arr.sort((x, y) => advertSortPrice(y) - advertSortPrice(x));
    case "newest":
    default:
      return arr.sort(
        (x, y) => new Date(y.createdAt) - new Date(x.createdAt)
      );
  }
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchList(props) {
  const { adverts } = useSelector(
    (state) => ({
      adverts: state.advert.searchKeyword.results,
    }),
    shallowEqual
  );

  const [pace, setPace] = useState(false);
  const [selectedCat, setSelectedCat] = useState(null);
  const [sortBy, setSortBy] = useState("newest");
  const [advertViewStyle, setAdvertViewStyle] = useState("grid");
  const [width, setWidth] = useState(window.innerWidth);
  const classes = useStyles();
  let query = useQuery();
  const keyword = query.get("kelime");

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (width < 768 && advertViewStyle === "list") setAdvertViewStyle("grid");
  }, [width, advertViewStyle]);

  useEffect(() => {
    if (Number(keyword) >= 180000) {
      props.history.push(`/ilan/${keyword}`);
    }
    setSelectedCat(null);
    setSortBy("newest");
    fetchSearchResult(keyword);
  }, [keyword]);

  function fetchSearchResult(kw) {
    setPace(true);
    advertEndpoint
      .searchAdvert(kw)
      .then((res) => res.data)
      .then((result) => {
        props.setAdvertsOfSearch(result.hits);
        setPace(false);
      });
  }

  // Arama sonuçlarını kategoriye göre grupla (büyükten küçüğe sayım).
  const groups = useMemo(() => {
    const map = new Map();
    (adverts || []).forEach((a) => {
      const cat = a.category || { _id: "none", name: "Diğer", slug: "" };
      const key = cat._id || cat.slug || "none";
      if (!map.has(key)) map.set(key, { key, category: cat, items: [] });
      map.get(key).items.push(a);
    });
    return Array.from(map.values()).sort(
      (x, y) => y.items.length - x.items.length
    );
  }, [adverts]);

  // Tek kategori varsa doğrudan listeye geç; aksi halde seçileni göster.
  const activeGroup = useMemo(() => {
    if (selectedCat) return groups.find((g) => g.key === selectedCat) || null;
    if (groups.length === 1) return groups[0];
    return null;
  }, [groups, selectedCat]);

  const sortedItems = useMemo(
    () => (activeGroup ? sortAdverts(activeGroup.items, sortBy) : []),
    [activeGroup, sortBy]
  );

  const total = adverts?.length || 0;
  const showOverview = !activeGroup && groups.length > 0;
  const canGoBack = groups.length > 1 && !!selectedCat;

  return (
    <LayoutV1>
      <Helmet>
        <title>Alıcılar - Arama Sonuçları</title>
        <meta
          name="description"
          content={`Alıcılar üzerinde yayınlanan ilanlar arasında "${keyword}" kelimesi ile ilgili olan ilanlar listesi.`}
        />
      </Helmet>
      <Backdrop className={classes.backdrop} open={pace}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className="page-content">
        <div
          className="dez-bnr-inr"
          style={{
            backgroundColor: "#fbfbfb",
            boxShadow: "rgb(0 0 0 / 6%) 0px 0px 10px 0px",
          }}
        >
          <div className="container">
            <div className="dez-bnr-inr-entry">
              <h1 className="text-black">"{keyword}" Arama Sonuçları</h1>
            </div>
          </div>
        </div>

        <div className="section-full bg-white content-inner-2">
          <div className="container">
            {total === 0 ? (
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="p-3">
                  <h3 className="m-b5 pl-3 text-center">
                    Aramanıza uygun ilan bulunamadı.
                  </h3>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => props.history.push("/")}
                >
                  Ana Sayfa
                </Button>
              </div>
            ) : showOverview ? (
              <>
                <div className="sr-summary">
                  "<b>{keyword}</b>" araması için <b>{total}</b> sonuç bulundu.
                  Bir kategori seçin.
                </div>
                <div className="sr-cat-grid">
                  {groups.map((g) => {
                    const color = g.category.color || "#11986e";
                    return (
                      <div
                        key={g.key}
                        className="sr-cat"
                        style={{ "--cat-color": color }}
                        onClick={() => setSelectedCat(g.key)}
                      >
                        <span className="sr-cat__icon">
                          {g.category.icon ? (
                            <img src={g.category.icon} alt={g.category.name} />
                          ) : (
                            <i className="fa fa-folder-o" />
                          )}
                        </span>
                        <span className="sr-cat__name">{g.category.name}</span>
                        <span className="sr-cat__count">
                          {g.items.length}
                          <span>ilan</span>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : activeGroup ? (
              <>
                <div className="job-bx-title clearfix">
                  <div
                    className="float-left d-flex align-items-center"
                    style={{ gap: 12 }}
                  >
                    {canGoBack ? (
                      <button
                        className="sr-back"
                        onClick={() => setSelectedCat(null)}
                      >
                        <i className="fa fa-angle-left" /> Tüm Kategoriler
                      </button>
                    ) : null}
                    <span className="fp-result-count">
                      {activeGroup.category.name} · {activeGroup.items.length} ilan
                    </span>
                  </div>

                  <div className="d-flex flex-row-reverse float-right align-items-center">
                    {width > 768 ? (
                      <div className="table-cell float-right p-tb5 p-r10 align-items-center justify-content-center">
                        <div className="d-flex flex-column align-items-center">
                          <div>
                            <Link
                              to={"#"}
                              className="p-lr5"
                              onClick={() => setAdvertViewStyle("list")}
                            >
                              <i className="fa fa-th-list" />
                            </Link>
                            <Link
                              to={"#"}
                              className="p-lr5"
                              onClick={() => setAdvertViewStyle("grid")}
                            >
                              <i className="fa fa-th" />
                            </Link>
                          </div>
                          <p className={classes.contentStyle}>Görüntüle</p>
                        </div>
                      </div>
                    ) : null}
                    <select
                      className="fp-sort"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                    >
                      {SORT_OPTIONS.map((o) => (
                        <option key={o.id} value={o.id}>
                          {o.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <ul
                  className="post-job-bx browse-job-grid row mt-4"
                  style={{ padding: 0 }}
                >
                  {sortedItems.map((item, index) =>
                    advertViewStyle === "grid" ? (
                      <AdvertCard
                        advert={item}
                        key={item.id || item._id || index}
                      />
                    ) : (
                      <AdvertCardListView
                        advert={item}
                        key={item.id || item._id || index}
                      />
                    )
                  )}
                </ul>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </LayoutV1>
  );
}

export default connect(null, {
  ...advertRedux.actions,
})(SearchList);
